import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Form } from 'semantic-ui-react'

import AppComponent from './app_component'
import ConfirmModal from './confirm_modal'

import { getFormLabelTranslations } from '../helpers'

class NewEntryModal extends AppComponent {
  constructor(props){
    super(props)

    const { id: selected_risk_id, name, hidden, column } = this.props.risk;
    this.state.column = column;
    this.state.risk = { name, hidden, selected_risk_id };
    this.state.formData = this.initializeFormData();
    this.state.formError = { work_phase: false, activity: false, hazard: false, unwanted_event: false }
    this.state.formKeys = this.getRequiredFormKeys()
    this.state.showConfirmSubmit = false
    this.state.warningStyle = { color: 'red', fontWeight: 'bold' }
  }

  initializeFormData = () => {
    const {
      is_custom,
      template_flags,
      work_phase_or_ambient_exposure, work_phase_spanish, work_phase_turkish,
      activity, activity_spanish, activity_turkish,
      hazard, hazard_spanish, hazard_turkish,
      unwanted_event, unwanted_event_spanish, unwanted_event_turkish
    } = this.props.risk;

    return {
      is_custom,
      template_flags,
      work_phase_or_ambient_exposure,
      work_phase_spanish,
      work_phase_turkish,
      activity,
      activity_spanish,
      activity_turkish,
      hazard,
      hazard_spanish,
      hazard_turkish,
      unwanted_event,
      unwanted_event_spanish,
      unwanted_event_turkish,
      'risk_description': '',
      'consequences_description': '',
      'actions': '',
      'manager': '',
      'effectiveness': '',
      'status': { dueDate: '', status: '' },
      'effectiveness2': '',
      'consequences': [
        { key: 'financial', value: '' },
        { key: 'safety', value: '' },
        { key: 'health', value: '' },
        { key: 'environmental', value: '' },
        { key: 'reputation', value: '' },
        { key: 'legal', value: '' },
        { key: 'community', value: '' },
      ],
      'new_consequences': [
        { key: 'new_financial', value: '' },
        { key: 'new_safety', value: '' },
        { key: 'new_health', value: '' },
        { key: 'new_environmental', value: '' },
        { key: 'new_reputation', value: '' },
        { key: 'new_legal', value: '' },
        { key: 'new_community', value: '' },
      ],
      'likelihood': { type: '', value: '' },
      'new_likelihood': { type: '', value: '' },
      '6x6_consequences': [
        { key: '6x6_financial', value: '' },
        { key: '6x6_safety', value: '' },
        { key: '6x6_hygiene', value: '' },
        { key: '6x6_environmental', value: '' },
        { key: '6x6_reputation', value: '' },
        { key: '6x6_legal', value: '' },
        { key: '6x6_community', value: '' },
      ],
      '6x6_new_consequences': [
        { key: '6x6_new_financial', value: '' },
        { key: '6x6_new_safety', value: '' },
        { key: '6x6_new_hygiene', value: '' },
        { key: '6x6_new_environmental', value: '' },
        { key: '6x6_new_reputation', value: '' },
        { key: '6x6_new_legal', value: '' },
        { key: '6x6_new_community', value: '' },
      ],
      '6x6_likelihood': { type: '', value: '' },
      '6x6_new_likelihood': { type: '', value: '' }
    }
  }

  onInputChange = (evt, { value }) => {
    var { formData } = this.state
    if(evt.target.name.includes('work_phase')){
      formData = this.updateColumnsForEnabledLanguages(formData, value, "work_phase", "work_phase_or_ambient_exposure")
    }
    if(evt.target.name.includes('activity')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "activity", "activity")
    }
    if(evt.target.name.includes('hazard')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "hazard", "hazard")
    }
    if(evt.target.name.includes('unwanted_event')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "unwanted_event", "unwanted_event")
    }
    this.setState({ formData })
  }

  renderFormInputs = () => {
    const { formData, formKeys } = this.state
    const formLabelTranslations = getFormLabelTranslations()
    var form = []

    formKeys.map((key, index)=>{
      let props = { rows: 2, key: index, label: formLabelTranslations[key], name: key, value: formData[key], onChange: this.onInputChange}
      this.addErrorIndicators(key, props)
      this.disableInputs(key, props)
      return form.push(<Form.TextArea {...props}/>)
    })
    
    return form
  }

  addErrorIndicators = (key, props) => {
    const { formError } = this.state
    if (key.includes('work_phase')) { props.error = formError.work_phase }
    else if (key.includes('activity')) { props.error = formError.activity }
    else if (key.includes('hazard')) { props.error = formError.hazard }
    else if (key.includes('unwanted_event')) { props.error = formError.unwanted_event }
  }

  disableInputs = (key, props) => {
    const { column } = this.state
    if (column==='activity' && key.includes('work_phase')) props.disabled = true
    if (column==='hazard' && key.includes('work_phase')) props.disabled = true
    if (column==='hazard' && key.includes('activity')) props.disabled = true
    if (column==='unwanted_event' && key.includes('work_phase')) props.disabled = true
    if (column==='unwanted_event' && key.includes('activity')) props.disabled = true
    if (column==='unwanted_event' && key.includes('hazard')) props.disabled = true
  }

  updateColumnsForEnabledLanguages = (formData, value, key, default_key) => {
    const { enabled_languages: enabledLanguages } = this.props.instanceConfig;
    for (const language of enabledLanguages) {
      if (language === "English") {
        formData[default_key] = value;
      } else {
        formData[`${key}_${language.toLowerCase()}`] = value;
      }
    }
    return formData;
  } 

  onSubmit = () => {
    if(this.props.loading || this.hasInvalidValues()) {
      return
    }

    let { risk, formData } = this.state
    risk.metadata = JSON.stringify(formData)
    this.props.onSubmit(risk)
  }

  confirmSubmit = () => {
    if(this.props.loading || this.hasInvalidValues()) {
      return
    }

    if(this.props.isTemplate) {
      return this.toggleConfirmSubmit(true)
    }

    this.onSubmit()

  }

  hasInvalidValues = () => {
    var { formData, formError, formKeys } = this.state
    formKeys.map((key)=>{
      if (key.includes('work_phase')) formError.work_phase = (formData[key].trim().length === 0)
      if (key.includes('activity')) formError.activity = (formData[key].trim().length === 0)
      if (key.includes('hazard')) formError.hazard = (formData[key].trim().length === 0)
      if (key.includes('unwanted_event')) formError.unwanted_event = (formData[key].trim().length === 0)
      return
    })

    this.setState({ formError })
  
    return (formError.work_phase || formError.activity || formError.hazard || formError.unwanted_event)
  }

  toggleConfirmSubmit = (show) => {
    this.setState({ showConfirmSubmit:show })
  }

  render() {
    return (
      <Modal size="tiny" open={ this.props.shown }>
        <Modal.Header>
          <div className="new-entry-modal-header">
            { this.props.headerText }
          </div>
        </Modal.Header>
        <Modal.Content>
          <Form>
            { this.renderFormInputs() }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' fluid size='medium' onClick={ () => this.confirmSubmit() } className="new-plan-button">
            {this.props.translations.submit_button}&nbsp;&nbsp;{this.props.loading && <i className="loading circle notched icon"></i>}
          </Button>
        </Modal.Actions>
        <i className="delete icon" onClick={ this.props.onClose }></i>
        {
          this.state.showConfirmSubmit &&
          <ConfirmModal
            open={this.state.showConfirmSubmit}
            header="Confirm Submit"
            message={
              <span>
                <span style={this.state.warningStyle}>WARNING: </span>
                <span>Are you sure that the information is exactly correct? Information <span style={this.state.warningStyle}>CANNOT</span> be edited or deleted after "Submit".</span>
              </span>
             }
            onProceed={()=>this.onSubmit()}
            translations={this.props.translations}
            close={()=>this.toggleConfirmSubmit(false)}
            yesLabel='Submit'
            noLabel='Back'
          />
        }
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    instanceConfig: state.instance.instanceConfig
  }
}

export default connect(mapStateToProps, {})(NewEntryModal);



// WEBPACK FOOTER //
// ./src/components/new_entry_modal.js